import { useViewportSize }     from "@mantine/hooks";
import { useEffect, useState } from "react";

import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";
import Layout     from "_components/pages/blogs/layout.js";
import useStyles  from "_styles/pages/blogs/category";

import CategoryPost from "./categoryPost";
import TagsDialog   from "./tagsDialog";

const CategorySection = ( { categories, tags, postArray, selectedCategory } ) => {

	const [ open, setOpen ]                 = useState ( false );
	const [ anchorEl, setAnchorEl ]         = useState ( null );
	const [ selectedTags, setSelectedTags ] = useState ( [] );
	const [ postList, setPostList ]         = useState ( [] );
	const { width }                         = useViewportSize ();
	let deviceViewTab                       = width <= 1250;
	let deviceMobileView                    = width <= 600;

	const handleClick = event => {
		setAnchorEl ( event.currentTarget );
		setOpen ( previousOpen => !previousOpen );
	};

	useEffect ( () => {
		setPostList ( postArray );
	}, [ selectedCategory ] );

	const canBeOpen = open && Boolean ( anchorEl );
	const id        = canBeOpen ? "transition-popper" : undefined;

	const { classes } = useStyles ( { deviceMobileView, deviceViewTab } );

	const handleCrossIcon = tag => {
		const filteredTentativeTags = selectedTags?.filter ( item => item.id !== tag.id );

		setSelectedTags ( filteredTentativeTags );
		filterPosts ( filteredTentativeTags );
	};

	const filterPosts = tags => {
		if ( !tags?.length ) {
			setPostList ( postArray );

			return;
		}
		const newPostList = [];

		postArray.forEach ( post => {
			const hasTag =  post.tags.find ( postTagId => tags.find ( tag => tag.id === postTagId ) );

			if ( hasTag )
				newPostList.push ( post );
		} );
		setPostList ( newPostList );
	};
	const onSelectTags = tags => {
		setSelectedTags ( tags );
		filterPosts ( tags );
	};

	return (
		<Layout
			categories       = { categories }
			selectedCategory = { selectedCategory }
		>
			<div className = { classes.categoryContainer }>
				<div className = { classes.categoryHeaderConatiner }>
					<span className = { classes.categoryHeading }>
						{selectedCategory}
					</span>

					<TagsDialog anchorEl = { anchorEl }
						id                  = { id }
						onSelect            = { onSelectTags }
						open                = { open }
						placement           = "bottom-start"
						selectedTags        = { selectedTags }
						setOpen             = { setOpen }
						setSelectedTags     = { setSelectedTags }
						tags                = { tags }
					/>

					{selectedTags && (
						<div className = { classes.selectedTagsWrapper }>
							{ selectedTags?.map ( tag => {
								return (
									<button key = { tag.tagId }
										className  = { classes.selectedTag }
										type       = "button"
									>
										<Typography
											title = { tag.name }
										/>

										<Icon className = { classes.tagCrossIcon }
											name           = "cross"
											onClick        = { () => {
												handleCrossIcon ( tag );
											} }
										/>
									</button>
								);
							} )}
						</div>
					)}

				</div>

				<div className = { classes.postsList }>
					{postList.map ( ( post, idx ) => {
						return (
							<CategoryPost
								key  = { idx }
								post = { post }
							/>
						);
					} )}
				</div>
			</div>

		</Layout>

	);
};

export default CategorySection;